export const useGrade = () => {
  
  const checkCorrectMultipleResponse = (question,userAnswer,isStudentHaveDiff) => {
    if(isStudentHaveDiff){
      const correctAnswers = question.answer;
      const userAnswers = userAnswer;
      const isCorrect = userAnswers.every((answer) => correctAnswers.includes(answer));
      return isCorrect;
    }
    const correctAnswers = question.answer;
    const userAnswers = userAnswer;
    const sortedCorrect = [...correctAnswers].sort();
    const sortedUser = [...userAnswers].sort();

    const isCorrect = sortedCorrect.length === sortedUser.length && 
      sortedCorrect.every((answer, index) => answer === sortedUser[index]);
    return isCorrect;
  };

  return { checkCorrectMultipleResponse };
};
